module.exports = __webpack_public_path__ + "media/images/entidades_organizadoras/fpul-0b61dc1099a29db2dbee6db85d6772dd.svg";